import * as types from '../../actions/actionTypes';

const initialState = {
  miteredSections: [],
};

export default function(state = initialState, action) {
  let filteredMiteredSections;
  switch(action.type) {
    case types.SHOW_SLAB_TOOL:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_MITERED_SECTIONS:
      state = {...state, miteredSections: action.payload.miteredSections};
      break;
    case types.ADD_MITERED_SECTION:
      return Object.assign({}, state, {
        miteredSections: [...state.miteredSections, action.payload]
      });
    case types.CHANGE_MITERED_SECTION:
      filteredMiteredSections = state.miteredSections.map((item) => {
        if (item.id !== action.payload.id) { return item }

        return {
          ...item,
          ...action.payload
        }
      })

      return Object.assign({}, state, { miteredSections: filteredMiteredSections });

    case types.DELETE_MITERED_SECTION:
      if (state.miteredSections.length === 0) {
        return state
      }

      filteredMiteredSections = state.miteredSections.filter((row) => row.id !== action.payload.id);

      return Object.assign({}, state, { miteredSections: filteredMiteredSections });
    case types.DELETE_ALL_MITERED_SECTIONS:
      return Object.assign({}, state, { miteredSections: []});
  }

  return state;
}
